const ROLE_STORAGE_KEY = "simplii.platform.role";

export const SLACK_IMPORT_ALLOWED_ROLES = new Set<string>([
    "SUPER_ADMIN",

    /*
     * Add this later to grant access:
     *
     * 'PLATFORM_SUPER_ADMIN',
     */
]);

export function normalizeSimpliiPlatformRole(value: unknown): string {
    return String(value ?? "")
        .trim()
        .replace(/[\s-]+/g, "_")
        .toUpperCase();
}

export function saveSimpliiPlatformRole(role: unknown): string {
    const normalizedRole = normalizeSimpliiPlatformRole(role);

    try {
        if (normalizedRole) {
            window.sessionStorage.setItem(ROLE_STORAGE_KEY, normalizedRole);
        } else {
            window.sessionStorage.removeItem(ROLE_STORAGE_KEY);
        }
    } catch {
        // Storage may be unavailable.
    }

    try {
        window.dispatchEvent(
            new CustomEvent("simplii:platform-role-changed", {
                detail: {
                    role: normalizedRole,
                },
            }),
        );
    } catch {
        // Ignore event failures.
    }

    return normalizedRole;
}

export function getSimpliiPlatformRole(): string {
    if (typeof window === "undefined") {
        return "";
    }

    try {
        return normalizeSimpliiPlatformRole(window.sessionStorage.getItem(ROLE_STORAGE_KEY));
    } catch {
        return "";
    }
}

export function canCurrentUserImportSlack(): boolean {
    return SLACK_IMPORT_ALLOWED_ROLES.has(getSimpliiPlatformRole());
}

export function clearSimpliiPlatformRole(): void {
    try {
        window.sessionStorage.removeItem(ROLE_STORAGE_KEY);
    } catch {
        // Ignore.
    }

    try {
        window.dispatchEvent(new Event("simplii:platform-role-changed"));
    } catch {
        // Ignore.
    }
}
